module.exports = __webpack_public_path__ + "img/comment.65705cd9.svg";